import React, { ReactElement, useState } from 'react';

import { ApiQueryParams, CheckboxTree, NestedFacet } from '../../../interfaces';
import { ExpandableNestedCheckbox } from './ExpandableNestedCheckbox';

interface Props {
    continent: NestedFacet;
    checked: CheckboxTree;
    checkboxClick: (path: string[]) => void;
    triggerFetch: (queryParams?: ApiQueryParams) => void;
    displayValue: (facet: NestedFacet) => string;
    sortChildren: (facet1: NestedFacet, facet2: NestedFacet) => number;
}

export const CollapsibleContinent: React.FC<Props> = ({
    continent,
    checked,
    checkboxClick,
    triggerFetch,
    displayValue,
    sortChildren,
}): ReactElement<Props> | null => {
    const [expanded, setExpanded] = useState(false);
    const continentChildren = [...(continent.children || [])];

    return (
        <div data-testid={`DestinationFilter-Continent-${continent.value}`}>
            <h3 className="u-t5 u-mt16 u-mb0">{displayValue(continent)}</h3>
            {continentChildren
                .sort(sortChildren)
                .map((country, index) =>
                    expanded || index < 3 ? (
                        <ExpandableNestedCheckbox
                            key={country.value}
                            facet={country}
                            ancestors={[]}
                            checked={checked}
                            checkboxClick={checkboxClick}
                            triggerFetch={triggerFetch}
                            displayValue={displayValue}
                            sortChildren={sortChildren}
                        />
                    ) : null
                )}
            {continentChildren.length > 3 && (
                <button
                    data-testid={`DestinationFilter-Continent-${continent.value}-toggle`}
                    className="button button--link"
                    onClick={(): void => setExpanded(!expanded)}>
                    {expanded ? 'Færre land' : 'Flere land...'}
                </button>
            )}
        </div>
    );
};
